import type { QueryClient } from '@tanstack/react-query';
import { indexedDbPersister } from './persister';

/**
 * Wipe the offline cache on logout.
 *
 * Because the QueryClient persists data to IndexedDB, cached workspace data and
 * user-authored notes would otherwise remain readable on disk after a user logs
 * out — a leak on shared devices. `clearAuthSession()` (in @shared/auth/session)
 * emits an `auth:cleared` event on every logout path; we listen once and clear:
 *  - the in-memory query/mutation cache (`queryClient.clear()`), which also
 *    discards any offline mutations queued by the departing user, and
 *  - the persisted IndexedDB copy (`persister.removeClient()`).
 *
 * Call once at startup, after the QueryClient is created.
 */
export function initOfflineCacheResetOnLogout(queryClient: QueryClient): void {
  window.addEventListener('auth:cleared', () => {
    queryClient.clear();
    void indexedDbPersister.removeClient();
  });
}
